var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","text-center":"","mb-4":""}},[_c('h1',[_vm._v("Page Missing")]),_c('p',[_vm._v("Sorry, but the page you requested isn't here!")]),_c('p',[_vm._v("(◞‸◟)")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }